const auth = [
    {
        alias: '知识库',
        name: 'bank',
        children: [
            {
                alias: '图文知识',
                name: 'bank-article',
                children: [
                    {alias: "全部", name: "bank-article-all"}
                ]
            },
            {
                alias: '视频科普',
                name: 'bank-uploadVideo',
                children: [
                    {alias: "全部", name: "bank-uploadVideo-all"}
                ]
            },
            {
                alias: '问卷管理',
                name: 'bank-questionnaire',
                children: [
                    {alias: "全部", name: "bank-questionnaire-all"}
                ]
            },
            {
                alias: '问候语',
                name: 'bank-greetings',
                children: [
                    {alias: "全部", name: "bank-greetings-all"}
                ]
            },
            {
                alias: '通用提醒',
                name: 'bank-remind',
                children: [
                    {alias: "全部", name: "bank-remind-all"}
                ]
            },
            // {
            //     alias: '内容推送',
            //     name: 'bank-push',
            //     children: [
            //         {alias: "生命周期", name: "bank-push-all"}
            //     ]
            // },
            // {
            //     alias: "周期活动管理",
            //     name: "bank-activity",
            //     children: [
            //         {alias: "全部", name: "bank-activity-all"}
            //     ],
            // },
        ]
    },
    {
        alias: '个人首页',
        name: 'my',
        children: [
            {
                alias: "个人首页",
                name: "my-info",
                children: [
                    {alias: "全部", name: "my-info-all"}
                ]

            }
        ]
    },
    {
        alias: '随访工单导出',
        name: 'report',
        children: [
            {
                alias: '患者随访表',
                name: 'report-patient',
                children: [
                    {alias: "全部", name: "report-patient-all"}
                ]
            },
            {
                alias: '专员随访工单(运营)',
                name: 'report-operation',
                children: [
                    {alias: "全部", name: "report-operation-all"}
                ]
            },
            {
                alias: '专员随访工单(基金会)',
                name: 'report-foundation',
                children: [
                    {alias: "全部", name: "report-foundation-all"}
                ]
            },
            {
                alias: '附表-公益专员架构表',
                name: 'report-public',
                children: [
                    {alias: "全部", name: "report-public-all"}
                ]
            },
            {
                alias: '验真结果',
                name: 'report-verificationResult',
                children: [
                    {alias: "全部", name: "report-verificationResult-all"}
                ]
            },
            {
                alias: '验真结果（基金会）',
                name: 'report-resultFoundation',
                children: [
                    {alias: "全部", name: "report-resultFoundation-all"}
                ]
            },{
                alias: '试点随访（基金会）',
                name: 'report-pointFollowUp',
                children: [
                    {alias: "全部", name: "report-pointFollowUp-all"}
                ]
            },

        ]
    },
    {
        alias: '内容推送',
        name: 'push',
        children: [
            {
                alias: "生命周期",
                name: "push-life",
                children: [
                    {alias: "全部", name: "push-life-all"}
                ]

            }
        ]
    },

    {
        alias: '组织架构',
        name: 'staff',
        children: [
            {
                alias: '组织架构',
                name: 'staff-staff',
                children: [
                    {alias: "维护权限", name: "staff-staff-safe"},
                    {alias: "权限限制", name: "staff-staff-wx"},
                ]
            },
        ]
    },
    {
        alias: '医院管理',
        name: 'hos',
        children: [
            {
                alias: '医院管理',
                name: 'hos-hos',
                children: [
                    {alias: "全部", name: "hos-hos-all"}
                ]
            },
        ]
    },
    {
        alias: '医生管理',
        name: 'doctor',
        children: [
            {
                alias: '医生管理',
                name: 'doctor-doctor',
                children: [
                    {alias: "全部", name: "doctor-doctor-all"}
                ]
            },
        ]
    },
    {
        alias: '药师管理',
        name: 'pharmacist',
        children: [
            {
                alias: '药师管理',
                name: 'pharmacist-pharmacist',
                children: [
                    {alias: "全部", name: "pharmacist-pharmacist-all"}
                ]
            },
        ]
    },
    {
        alias: '活动管理',
        name: 'activeManage',
        children: [
            {
                alias: '活动管理',
                name: 'activeManage-activeManage',
                children: [
                    {alias: "全部", name: "activeManage-activeManage-all"}
                ]
            },
        ]
    },


    {
        alias: '注册审核',
        name: 'sick',
        children: [
            {
                alias: '注册审核',
                name: 'sick-audit',
                children: [
                    {alias: "审核", name: "sick-audit-pass"},
                    {alias: "拒绝", name: "sick-audit-refuse"},
                    {alias: "删除", name: "sick-audit-del"},
                ]
            },
        ]
    },
    {
        alias: '发票审核',
        name: 'bill',
        children: [
            {
                alias: '发票审核',
                name: 'bill-audit',
                children: [
                    {alias: "审核", name: "bill-audit-pass"},
                    {alias: "拒绝", name: "bill-audit-refuse"},
                    {alias: "删除", name: "bill-audit-del"},
                ]
            },
        ]
    },{
        alias: '随访工单',
        name: 'visit',
        children: [
            {
                alias: '随访工单',
                name: 'visit-audit',
                children: [
                    {alias: "审核", name: "visit-audit-pass"},
                    {alias: "拒绝", name: "visit-audit-refuse"},
                    {alias: "删除", name: "visit-audit-del"},
                ]
            },
        ]
    },
    {
        alias: '随访指定清单',
        name: 'follow-up',
        children: [
            {
                alias: '随访指定清单',
                name: 'follow-up-list',
                children: [
                    {alias: "全部", name: "follow-up-list-all"}
                ]
            },
            {
                alias: '随访排除清单',
                name: 'follow-up-unlist',
                children: [
                    {alias: "全部", name: "follow-up-unlist-all"}
                ]
            },
        ]
    },
    {
        alias: '留言咨询',
        name: 'advisory',
        children: [
            {
                alias: '留言咨询',
                name: 'advisory-messages',
                children: [
                    {alias: "全部", name: "advisory-messages-all"}
                ]
            },
        ]
    },
    {
        alias: '患者数据',
        name: 'patient',
        children: [
            {
                alias: '详细数据',
                name: 'patient-data',
                children: [
                    {alias: "全部", name: "patient-data-all"}
                ]
            },
            {
                alias: '患者统计',
                name: 'patient-stat',
                children: [
                    {alias: "全部", name: "patient-stat-all"}
                ]
            },
        ]
    },
    {
        alias: '数据申请',
        name: 'hisDataEdit',
        children: [
            {
                alias: '数据申请',
                name: 'hisDataEdit-hisDataEdit',
                children: [
                    {alias: "全部", name: "hisDataEdit-hisDataEdit-all"}
                ]
            },
        ]
    },
    {
        alias: '数据修复',
        name: 'dataRecovery',
        children: [
            {
                alias: '数据修复',
                name: 'dataRecovery-dataRecovery',
                children: [
                    {alias: "全部", name: "dataRecovery-dataRecovery-all"}
                ]
            },
        ]
    },
    {
        alias: '填报进度',
        name: 'schedule',
        children: [
            {
                alias: '填报汇总',
                name: 'export-stat',
                children: [
                    {alias: "全部", name: "export-stat-all"}
                ]
            },
            {
                alias: '详细数据',
                name: 'schedule-data',
                children: [
                    {alias: "全部", name: "schedule-data-all"}
                ]
            },
            {
                alias: '统计',
                name: 'schedule-stat',
                children: [
                    {alias: "全部", name: "schedule-stat-all"}
                ]
            },
        ]
    },

    {
        alias: '运营用户',
        name: 'sys',
        children: [
            {
                alias: '用户',
                name: 'sys-user',
                children: [
                    {alias: "全部", name: "sys-user-all"}
                ]
            },
            {
                alias: '角色',
                name: 'sys-role',
                children: [
                    {alias: "全部", name: "sys-role-all"}
                ]
            },
        ]
    },

    {
        alias: '病种管理',
        name: 'ill',
        children: [
            {
                alias: '病种管理',
                name: 'ill-ill',
                children: [
                    {alias: "全部", name: "ill-ill-all"}
                ]
            },
        ]
    },

    {
        alias: '操作日志',
        name: 'operation',
        children: [
            {
                alias: '操作日志',
                name: 'operation-operation',
                children: [
                    {alias: "全部", name: "operation-operation-all"}
                ]
            },
        ]
    },
    {
        alias: '字典管理',
        name: 'dictionaries',
        children: [
            {
                alias: '字典管理',
                name: 'dictionaries-dictionaries',
                children: [
                    {alias: "全部", name: "dictionaries-dictionaries-all"}
                ]
            },
        ]
    },
    {
        alias: '直播管理',
        name: 'live',
        children: [
            {
                alias: '直播管理',
                name: 'live-live',
                children: [
                    {alias: "全部", name: "live-live-all"}
                ]
            },
        ]
    },

    {
        alias: '积分配置',
        name: 'integral',
        children: [
            {
                alias: '积分规则',
                name: 'integral-rule',
                children: [
                    {alias: "全部", name: "integral-rule-all"}
                ]
            },
            {
                alias: '积分等级',
                name: 'integral-level',
                children: [
                    {alias: "全部", name: "integral-level-all"}
                ]
            },
            {
                alias: '积分设置',
                name: 'integral-setup',
                children: [
                    {alias: "全部", name: "integral-setup-all"}
                ]
            },
        ]
    },
    {
        alias: '药店列表',
        name: 'drugstore',
        children: [
            {
                alias: '药店列表',
                name: 'drugstore-drugstore',
                children: [
                    {alias: "全部", name: "drugstore-drugstore-all"}
                ]
            },
        ]
    },
    {
        alias: '产品配置',
        name: 'drugConfig',
        children: [
            {
                alias: '产品配置',
                name: 'drugConfig-drugConfig',
                children: [
                    {alias: "全部", name: "drugConfig-drugConfig-all"}
                ]
            },
        ]
    },
];
export default auth
